module.exports = __webpack_public_path__ + "media/images/login-bg-6872f6be36d60bf00d1926ec22e744ad.jpg";